
const requestFullscreen = element => {
  element = element || document.documentElemen
  if (element.requestFullscreen) {
    element.requestFullscreen()
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen()
  } else if (element.webkitRequestFullScreen) {
    element.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT)
  }
}
const exitFullscreen = () => {
  console.log(document.exitFullscreen, 'ppppp')
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.oCancelFullScreen) {
    document.oCancelFullScreen()
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen()
  }
}
export function fullScreenSwitch(isOpen, dom) {
  document.fullscreenEnabled = document.fullscreenEnabled || document.mozFullScreenEnabled || document.documentElement.webkitRequestFullScreen
  if (!document.fullscreenEnabled) {
    return
  }
  if (isOpen) {
    requestFullscreen(dom)
  } else {
    exitFullscreen()
  }
}
